import { FormControl, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomInputLabel,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomSelectforFamily,
  CustomTextFeildforFamily,
  StyledDateContainer,
} from "../../common/StyledComponents/StyledFields";
import { ValidationError, object, string } from "yup";
import styles from "../reportSection.module.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { apiRequest } from "../../../infrastructure/backendService";
import { ClipLoader } from "react-spinners";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";

interface ErrorMessageTypesBySignIn {
  signInName: string;
  searchByWeekly: string;
  searchByMonthly: string;
  searchByQuarterly: string;
  selectYear: string;
  searchYear: string;
}
const formFieldsSignIn = {
  signInName: "",
  searchByWeekly: dayjs().format("MM-DD-YYYY"),
  searchByMonthly: "",
  searchByQuarterly: "",
  selectYear: "",
  searchYear: "",
};
const SummaryBySignInName = ({ sendDataToParent, getReportData }: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessageSignIn, setErrorMessageSignIn] =
    useState<ErrorMessageTypesBySignIn>({ ...formFieldsSignIn });
  const [formDataSignIn, setFormDataSignIn] = useState(formFieldsSignIn);

  const [isFieldName, setIsFieldName] = useState("");
  const validationSchemaSignIn = object().shape({
    signInName: string().required("SignIn-Name is required"),
  });

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const Quarterly = ["Jan-March", "April-June", "July-Sept", "Oct-Dec"];

  const generateArrayOfYears = () => {
    let currentYear = new Date().getFullYear();
    var lastTenYears = currentYear - 10;
    var years = [];

    for (var i = currentYear; i >= lastTenYears; i--) {
      years.push(i);
    }
    return years;
  };

      const handleSearchByDateChange = (field: any, value: any) => {
        console.log(value);
        if (field === "searchByWeekly") {
            let formattedDate = dayjs(value, "MM/DD/YYYY");
            setFormDataSignIn({
              ...formDataSignIn,
              [field]: formattedDate.isValid()
                ? formattedDate.format("MM/DD/YYYY")
                : "",
            });
          } else {
            setFormDataSignIn({
                ...formDataSignIn,
                [field]: value,
            });
        }
        /* Enable and disable of fields accordingly */
        // if(field === "searchByWeekly") {
        //     setIsMonthSearch(true);
        //     setIsQuarterlySearch(true);
        // } else if(field === "searchByMonthly" || field === "selectYear") {
        //     setIsWeekSearch(true);
        //     setIsQuarterlySearch(true);
        // } else if(field === "searchByQuarterly" || field === "searchYear") {
        //     setIsWeekSearch(true);
        //     setIsMonthSearch(true);
        // }
        /* Enable and disable of fields accordingly */
        setIsFieldName(field);
    };

  const handleClear = () => {
    setFormDataSignIn(formFieldsSignIn);
  };

  const getPoojaBookingSummarySignInReports = () => {
    const valueSelected: any = Object.entries(formDataSignIn).reduce(
      (a, [k, v]) => (v === "" ? a : (((a as any)[k] = v), a)),
      {}
    );
    let reqBody: any = {};
    reqBody.signInName = valueSelected["signInName"];
    if (isFieldName === "searchByWeekly") {
      reqBody.searchStartDate = valueSelected[isFieldName];
      reqBody.searchEndDate = dayjs(valueSelected[isFieldName], "MM/DD/YYYY")
        .add(1, "week")
        .format("MM/DD/YYYY");
    } else if (
      isFieldName === "searchByMonthly" ||
      isFieldName === "selectYear"
    ) {
      let monthStartDate = dayjs(
        new Date(valueSelected["selectYear"], valueSelected["searchByMonthly"])
      ).format("MM/DD/YYYY");
      let monthEndDate = dayjs(
        new Date(
          valueSelected["selectYear"],
          valueSelected["searchByMonthly"] + 1,
          0
        )
      ).format("MM/DD/YYYY");
      reqBody.searchStartDate = monthStartDate;
      reqBody.searchEndDate = monthEndDate;
    } else if (
      isFieldName === "searchByQuarterly" ||
      isFieldName === "searchYear"
    ) {
      let quarterStartDate = dayjs(
        new Date(
          valueSelected["searchYear"],
          valueSelected["searchByQuarterly"]
        )
      ).format("MM/DD/YYYY");
      let quarterEndDate = dayjs(
        new Date(
          valueSelected["searchYear"],
          valueSelected["searchByQuarterly"] + 3,
          0
        )
      ).format("MM/DD/YYYY");
      reqBody.searchStartDate = quarterStartDate;
      reqBody.searchEndDate = quarterEndDate;
    }
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint:
        "/report-dashboard/reports/pooja/POOJA_BOOKING_SUMMARY_BY_SIGN_IN_NAME/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        const response = res.data;
        const resultData = response.map((value: any) => {
          return {
            "Name of Priest": `${value.firstname} ${value.middlename} ${value.lastname}`,
            "Number Of Poojas Booked": value.totalNumberOfPoojaBooked,
            "Total Time Booked": value.totalTimeBooked,
          };
        });
        getReportData(resultData);
        const totalPoojasBooked = resultData.reduce((acc:any, curr:any) => acc + curr["Number Of Poojas Booked"], 0);
        const totalTimeBooked = resultData.reduce((acc:any, curr:any) => acc + curr["Total Time Booked"], 0);   
        sendDataToParent(true, {reqBody,totalPoojasBooked,totalTimeBooked});
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handlSubmitSignIn = async () => {
    const errors: ErrorMessageTypesBySignIn = {
      ...formFieldsSignIn,
    };
    try {
      // Validate the form data against the validation schema
      await validationSchemaSignIn.validate(formDataSignIn, {
        abortEarly: false,
      });
      // If validation passes, you can submit the form
      setErrorMessageSignIn(errors);
      getPoojaBookingSummarySignInReports();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypesBySignIn] = e.message;
          }
        });
      }
      setErrorMessageSignIn(errors);
    }
  };
  const DobDatePickerWeekly = (): React.ReactElement => {
    return (
      <div className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formDataSignIn.searchByWeekly
                    ? dayjs(formDataSignIn.searchByWeekly, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  handleSearchByDateChange("searchByWeekly", value);
                }}
                disableFuture
                className={styles.dateFeildforfamily
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const SearchByMonthlySignInDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formDataSignIn.searchByMonthly}
            onChange={(e) => {
              handleSearchByDateChange("searchByMonthly", e.target.value);
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
          >
            {months.map((month: any, index: any) => (
              <CustomMenuItem value={index} key={index}>
                {month}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
      </>
    );
  };
  const SelectYearSignInDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formDataSignIn.selectYear}
            onChange={(e) => {
              handleSearchByDateChange("selectYear", e.target.value);
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
          >
            {generateArrayOfYears().map((year: any) => (
              <CustomMenuItem value={year} key={year}>
                {year}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
      </>
    );
  };
  const SearchByQuarterlySignInDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formDataSignIn.searchByQuarterly}
            onChange={(e) => {
              handleSearchByDateChange("searchByQuarterly", e.target.value);
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
          >
            {Quarterly.map((quarter: any, index: any) => (
              <CustomMenuItem value={index * 3} key={index}>
                {quarter}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
      </>
    );
  };
  const SearchYearSignInDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formDataSignIn.searchYear}
            onChange={(e) => {
              handleSearchByDateChange("searchYear", e.target.value);
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
          >
            {generateArrayOfYears().map((year: any) => (
              <CustomMenuItem value={year} key={year}>
                {year}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
      </>
    );
  };
  return (
    <div>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Sign-In Name ", true)}
          <CustomTextFeildforFamily
            fullWidth
            required
            value={formDataSignIn.signInName}
            onChange={(e) => {
              const inputValue = e.target.value;
              setErrorMessageSignIn({ ...errorMessageSignIn, signInName: "" });
              handleSearchByDateChange("signInName", inputValue);
            }}
            className={
              errorMessageSignIn.signInName
                ? styles.errorTextField
                : styles.dateFeild
            }
          />
          {errorMessageSignIn.signInName ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessageSignIn.signInName}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Search By Weekly", false)}
          {DobDatePickerWeekly()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Search By Monthly", false)}
          {SearchByMonthlySignInDropdown()}
        </Grid>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Select By Year", false)}
          {SelectYearSignInDropdown()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Search By Quarterly", false)}
          {SearchByQuarterlySignInDropdown()}
        </Grid>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Search By Year", false)}
          {SearchYearSignInDropdown()}
        </Grid>
      </Grid>
      <Grid sx={{ marginTop: "20px", display: "flex", gap: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitSignIn}
          disabled={loading}
          id="submit"
        >
        <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
      </Grid>
    </div>
  );
};
export default SummaryBySignInName;
